// Ver _docs/frontend/cable_stream_sources.md
import "./modules/cable_stream_source_element"
import "@hotwired/turbo-rails"
window.Turbo = Turbo
Turbo.start()

import Rails from "@rails/ujs"
import * as ActiveStorage from "@rails/activestorage"
import "./channels"
import "./controllers"

// Utilidades globales
import moment from "moment"
window.moment = moment

import $ from "jquery"
window.$ = $
window.jQuery = $

import toastr from "toastr"
window.toastr = toastr

// Turbo cachea el snapshot del DOM al navegar, incluyendo el #toast-container.
document.addEventListener("turbo:before-cache", () => {
  if (window.toastr) window.toastr.clear()
})

// Un <img loading="lazy"> clonado en el snapshot re-difiere su carga al
// restaurar (back) y el pop-in por tarjeta se ve como parpadeo de imágenes.
document.addEventListener("turbo:before-cache", () => {
  document.querySelectorAll('img[loading="lazy"]').forEach((img) => {
    if (img.complete) img.loading = "eager"
  })
})

// Dependencies package
import "chartkick/chart.js"
import "selectize"
import "trix"
import "@rails/actiontext"
import "@hotwired/hotwire-native-bridge"

// Módulos personalizados (ex-packs)
import "./modules/popovers"
import "./modules/dashboard"
import "./modules/parallax"
import "./modules/config_selectize"
import "./modules/spinner"
import "./modules/native_cart_resume"
import "./modules/time_zone"
import "./modules/modal_session"
import "./modules/payment_brick"
import "./modules/status_brick"
import "./modules/collapse_ingredients"
import "./modules/redirect_pwa"
import "./modules/preview_img"
import "./modules/modal"
import "./modules/sw_custom"
import "./modules/wallet_brick"

// Callback de Google Maps
if (!window.initMap) {
  window.initMap = function (...args) {
    const event = new CustomEvent("google-maps-callback", {
      bubbles: true,
      cancelable: true,
      detail: { args: args }
    });
    window.dispatchEvent(event);
  }
}


// Inicializar servicios de Rails
Rails.start()
ActiveStorage.start()
